var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73766 6.34579C4.42153 5.9249 4.2664 5.4048 4.30032 4.8795C4.33423 4.35421 4.55495 3.85837 4.92257 3.48162L7.28507 1.07596C7.48183 0.873902 7.71707 0.713307 7.97691 0.603651C8.23675 0.493995 8.51592 0.4375 8.79795 0.4375C9.07998 0.4375 9.35915 0.493995 9.61899 0.603651C9.87883 0.713307 10.1141 0.873902 10.3108 1.07596C10.7124 1.48777 10.9371 2.04019 10.9371 2.61537C10.9371 3.19056 10.7124 3.74298 10.3108 4.15479L8.73057 5.86396M6.37216 4.90146C6.77076 5.3128 6.99366 5.86312 6.99366 6.43592C6.99366 7.00871 6.77076 7.55903 6.37216 7.97037L4.08899 10.3008C3.89224 10.5028 3.65704 10.6633 3.39725 10.7729C3.13747 10.8825 2.85836 10.9389 2.57641 10.9389C2.29445 10.9389 2.01534 10.8825 1.75556 10.7729C1.49578 10.6633 1.26057 10.5028 1.06382 10.3008C0.662256 9.88898 0.4375 9.33656 0.4375 8.76137C0.4375 8.18619 0.662256 7.63376 1.06382 7.22196L2.58457 5.62421",
    stroke: "#262F5F",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLink);
export default __webpack_public_path__ + "static/media/send-link.cc16743f7bb31e2ef0e5d70e98834981.svg";
export { ForwardRef as ReactComponent };